export const signedIn = "security.signedIn";
export const logout = "security.logout";
export const accessDenied = "security.accessDenied";
export const serverError = "security.serverError";
export const user = "security.user";
export const showSessionExpiredModal = "security.showSessionExpiredModal";
